/*
 * Os dados dos eventos como o servidor manda (extend/events.php): o cartão
 * inteiro no primeiro post (`canelaEvent` do post) e o resumo na discussão
 * (`canelaEvent` da discussão), mais as chaves do admin.
 */
import app from 'flarum/forum/app';
import { forumBool, isExtensionEnabled } from '../../utils/settings';

/** Uma pessoa, só com o público. */

/** Uma ocorrência da lista de próximos eventos (a agenda, GET /api/canela-events). */

/** Um documento do recurso `canela-events` (CalendarEventResource no PHP). */

/** O cartão do evento de uma resposta do recurso (o cartão, a presença): os atributos, com o id. */
export function eventFromDocument(document) {
  const resource = Array.isArray(document.data) ? document.data[0] : document.data;
  return resource ? {
    ...(resource.attributes || {}),
    id: Number(resource.id)
  } : null;
}

/**
 * A agenda como as telas a usam: uma linha por ocorrência, em ordem, com o
 * nome do evento (ou o título da discussão) e a discussão.
 */
export function upcomingFromDocument(document) {
  const discussions = new Map();
  (document.included || []).forEach(item => {
    if (item.type === 'discussions') discussions.set(item.id, item.attributes || {});
  });
  const items = [];
  (Array.isArray(document.data) ? document.data : [document.data]).forEach(event => {
    const attributes = event.attributes || {};
    const discussionId = event.relationships?.discussion?.data?.id || '';
    const discussion = discussions.get(discussionId) || {};
    (attributes.occurrences || []).forEach(occurrence => {
      items.push({
        id: Number(event.id),
        name: attributes.name || discussion.title || null,
        startsAt: occurrence.startsAt,
        endsAt: occurrence.endsAt,
        recurrence: attributes.recurrence ?? null,
        timezone: attributes.timezone ?? null,
        going: attributes.going ?? 0,
        discussion: {
          id: discussionId,
          title: discussion.title ?? null,
          slug: discussion.slug ?? null
        }
      });
    });
  });
  return items.sort((a, b) => a.startsAt < b.startsAt ? -1 : a.startsAt > b.startsAt ? 1 : 0);
}
export const eventsSettings = {
  /** O backend carregado e o recurso ligado. */
  on: () => forumBool('canelaEventsBackend', false) && forumBool('canelaEventsEnabled', true),
  /** O id da tag dos eventos ('' = qualquer discussão). */
  tagId: () => String(app.forum?.attribute('canelaEventsTag') || ''),
  chat: () => eventsSettings.on() && forumBool('canelaEventsChat', true) && isExtensionEnabled('ramon-chat'),
  dockedChat: () => eventsSettings.chat() && forumBool('canelaEventsDockedChat', true),
  listBadge: () => eventsSettings.on() && forumBool('canelaEventsListBadge', true),
  upcoming: () => eventsSettings.on() && forumBool('canelaEventsUpcoming', true)
};

/** A tag dos eventos, quando escolhida e carregada. */
export function eventsTag() {
  const id = eventsSettings.tagId();
  return id && isExtensionEnabled('flarum-tags') ? app.store.getById('tags', id) || null : null;
}

/** As tags dadas incluem a dos eventos (sem tag escolhida, sempre). */
export function tagsAllowEvents(tags) {
  const id = eventsSettings.tagId();
  if (!id || !isExtensionEnabled('flarum-tags')) return true;
  return (tags || []).some(tag => tag && tag.id() === id);
}
export function postEvent(post) {
  return post?.attribute('canelaEvent') || null;
}
export function discussionEvent(discussion) {
  return discussion?.attribute('canelaEvent') || null;
}

/** A pessoa como modelo do store (para o Avatar e o link do perfil). */
export function personModel(person) {
  const existing = app.store.getById('users', person.id);
  if (existing) return existing;
  return app.store.pushObject({
    type: 'users',
    id: person.id,
    attributes: {
      username: person.username,
      displayName: person.displayName,
      avatarUrl: person.avatarUrl,
      slug: person.slug
    }
  });
}
export function apiUrl(path) {
  return `${app.forum.attribute('apiUrl')}${path}`;
}
flarum.reg.add('ramon-canela', 'forum/features/events/model', { eventFromDocument: eventFromDocument,upcomingFromDocument: upcomingFromDocument,eventsSettings: eventsSettings,eventsTag: eventsTag,tagsAllowEvents: tagsAllowEvents,postEvent: postEvent,discussionEvent: discussionEvent,personModel: personModel,apiUrl: apiUrl, });